<script lang="ts" setup></script>

<template>
  <v-chip
    class="text-uppercase font-size-11 rounded font-weight-600 bg-grey-darken-2 px-2"
    density="compact"
    size="small"
  >
    Deleted
  </v-chip>
</template>
